// app/javascript/components/shared/ui/DragHandle.js
//
// Drag affordance — picked up by SortableJS via `.sortable-handle`. Not a
// button, just a styled span. The parent row should have the `group` class
// so the handle can fade in on hover via the `reveal` variant.
import React from "react"
import { cva } from "class-variance-authority"
import clsx from "clsx"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

export const dragHandleVariants = cva(
  "sortable-handle flex items-center justify-center cursor-grab text-slate-400 transition-opacity",
  {
    variants: {
      reveal: {
        always:  "opacity-100",
        // Stays dim until the parent row is hovered (`group-hover`).
        onHover: "opacity-30 group-hover:opacity-100",
      },
      size: {
        sm: "h-7 w-5 text-xs",
        md: "h-9 w-5 text-sm",
      },
    },
    defaultVariants: { reveal: "always", size: "md" },
  }
)
const DragHandle = ({ reveal, size, className, icon = "grip-vertical", title = "Glisser pour réordonner", ...props }) => (
  <span
    title={title}
    className={clsx(dragHandleVariants({ reveal, size }), className)}
    {...props}
  >
    <FontAwesomeIcon icon={icon} />
  </span>
)

export default DragHandle
